import { ID } from '@libs/interfaces/layouts'
import { __ } from '@libs/utilities'
import { Button, Popover } from '@blueprintjs/core'
import { useState } from 'react'
import { attachTypes } from '../attaches/AttachTypes.entity'



interface IAttachFormProps {
    onInsertNew: (id: ID) => void
}
const AttachForm = (props: IAttachFormProps) :JSX.Element => {
    const [ current, setCurrent ] = useState( attachTypes()[ 0 ] )
    const onInsertNew = () =>    { 
        props.onInsertNew( current.id )
    } 
    return (
        <div className='d-flex justify-content-center milestone-attach-cont' data-testid="milestone-attache-form">
            <div className='d-flex flex-wrap'>
                <Button variant='minimal' className='text-dark opacity_5' onClick={onInsertNew} data-testid="milestone-attach-insert-btn">
                    { __( "Insert new include by" ) } {__(current.title) }
                </Button>
                <Popover 
                    popoverClassName=' mx-md-0 mx-auto '
                    content={
                        <div className="square3 card bg-light overflow-y-auto-thin justify-content-start p-0" data-testid="milestone-attach-popover">
                            <div className=' p-0'>
                            {
                                attachTypes().map(type => {
                                    return <Button 
                                        fill 
                                        variant='minimal' 
                                        className='py-3'
                                        onClick={ ( ) => setCurrent( type ) }
                                        key={type.id}
                                        data-testid={ `milestone-attach-type_${ type.id }` }
                                    >
                                        <small>
                                            {__(type.title)}
                                        </small>
                                    </Button>
                                })
                            }
                            </div>
                        </div>
                    }
                >
                    <Button className="pl-4 milestone-attach-change-btn text-dark" variant='minimal' data-testid="milestone-attach-type-btn">
                        {__("Change type")}
                    </Button>
                </Popover>
            </div>
        </div>
    )
}
 

export default AttachForm